import { lazy } from 'react'

export const OrderDetailLazy = lazy(() => import('./OrderDetail'))
